import { createSlice } from "@reduxjs/toolkit";

const CreateUserSupplyOrderSlice = createSlice({
  name: "CreateUserSupplyOrderService",
  initialState: {
    loading: false,
    orderSupplyData: null,
    error: null,
    success: false
  },
  reducers: {
    CreateUserSupplyOrderInit(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    CreateUserSupplyOrderSuccess(state, action) {
      state.loading = false;
      state.orderSupplyData = action.payload;
      state.success = true;
    },
    CreateUserSupplyOrderFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    CreateUserSupplyOrderReset(state) {
      return {
        ...state,
        loading: false,
        orderSupplyData: null,
        success: false,
        error: null
      };
    }
  }
});

export const {
  CreateUserSupplyOrderInit,
  CreateUserSupplyOrderSuccess,
  CreateUserSupplyOrderFailure,
  CreateUserSupplyOrderReset
} = CreateUserSupplyOrderSlice.actions;

export default CreateUserSupplyOrderSlice.reducer;
